export const NAME = 'messageCenter';
